/**
 * @flow
 * @relayHash 108eb1b26fa00e7482868f819bb62e56
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type collectionList_viewer$ref = any;
export type collectionList_QueryVariables = {| |};
export type collectionList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: collectionList_viewer$ref,
  |},
|};
*/


/*
query collectionList_Query {
  viewer {
    ...collectionList_viewer
    id
  }
}

fragment collectionList_viewer on Viewer {
  id
  collections(first: 1000) {
    total
    edges {
      node {
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        tracks {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  collection_categories(first: 1000) {
    edges {
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000,
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "collectionList_Query",
  "id": null,
  "text": "query collectionList_Query {\n  viewer {\n    ...collectionList_viewer\n    id\n  }\n}\n\nfragment collectionList_viewer on Viewer {\n  id\n  collections(first: 1000) {\n    total\n    edges {\n      node {\n        id\n        description\n        name\n        slug\n        category {\n          id\n          name\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        tracks {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  collection_categories(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "collectionList_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "collectionList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "collectionList_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "collections",
            "storageKey": "collections(first:1000)",
            "args": v1,
            "concreteType": "CollectionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Collection",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CollectionCategory",
                        "plural": false,
                        "selections": [
                          v0,
                          v2
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assets",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Asset",
                        "plural": true,
                        "selections": [
                          v0,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "version",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "type",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "file_format",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "path",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "metadata",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tracks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Track",
                        "plural": true,
                        "selections": [
                          v0
                        ]
                      },
                      v3
                    ]
                  },
                  v4
                ]
              },
              v5
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "collections",
            "args": v1,
            "handle": "connection",
            "key": "list_collections",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "collection_categories",
            "storageKey": "collection_categories(first:1000)",
            "args": v1,
            "concreteType": "CollectionCategoryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategoryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionCategory",
                    "plural": false,
                    "selections": [
                      v0,
                      v2,
                      v3
                    ]
                  },
                  v4
                ]
              },
              v5
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "collection_categories",
            "args": v1,
            "handle": "connection",
            "key": "list_collection_categories",
            "filters": []
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '3e4aa194cfd265b0954cfab39b85eb6e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/collectionList_Query.graphql.js